/** VistoeraTASK-00411 — bounded auto-retry policy for Capability Provider
 * Options fetches. Deliberately zero imports (not even React) so the
 * policy itself stays testable without a jsdom/React-render harness —
 * `useCapabilityProviderOptions.ts` is the only caller. */

const AUTO_RETRY_DELAYS_MS = [3000, 8000]

/** `attempt` is 0-indexed (retries already performed so far). Returns the
 * delay (ms) before the next retry, or `null` once retries are exhausted
 * (caller then surfaces the real "加载失败" state instead of retrying
 * forever). */
export function nextAutoRetryDelayMs(attempt: number): number | null {
  return attempt < AUTO_RETRY_DELAYS_MS.length ? AUTO_RETRY_DELAYS_MS[attempt] : null
}
